(function () {
  const VIMEO_PLAYER_SRC = 'https://player.vimeo.com/video/';
  const VIMEO_OEMBED = 'https://vimeo.com/api/oembed.json?url=';
  const YOUTUBE_OEMBED = 'https://www.youtube.com/oembed?format=json&url=';
  const YOUTUBE_THUMB = 'https://img.youtube.com/vi/';
  const PLAY_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M8 5.14v13.72L19 12 8 5.14z" fill="currentColor"/></svg>';
  const CHROME_HTML =
    '<div class="we-product-videos__chrome">' +
    '<button type="button" class="we-product-videos__ctrl" data-we-pv-mute aria-label="Ton umschalten" aria-pressed="false">' +
    '<svg class="we-product-videos__icon-volume" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M4 9v6h4l5 5V4L8 9H4z" fill="currentColor"/><path d="M16.5 12c0-1.77-1-3.29-2.5-4.03v8.05c1.5-.74 2.5-2.26 2.5-4.02z" fill="currentColor"/><path d="M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" fill="currentColor"/></svg>' +
    '<svg class="we-product-videos__icon-muted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M4 9v6h4l5 5V4L8 9H4z" fill="currentColor"/><path d="M19.8 4.2 18.4 2.8 4.2 17l1.4 1.4 3.1-3.1H8l5 5V14.8l5.4-5.4c.1.5.1 1 .1 1.6 0 1.8-1 3.3-2.5 4v2.1c2.9-.9 5-3.5 5-6.7 0-1.1-.3-2.2-.7-3.1l2.1-2.1z" fill="currentColor"/></svg>' +
    '</button>' +
    '<button type="button" class="we-product-videos__ctrl" data-we-pv-fs aria-label="Vollbild">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false"><path d="M7 14H5v5h5v-2H7v-3zm12 0h-2v3h-3v2h5v-5zM7 7h3V5H5v5h2V7zm12 3V5h-5v2h3v3h2z" fill="currentColor"/></svg>' +
    '</button>' +
    '</div>';
  const VIMEO_HIT_HTML =
    '<button type="button" class="we-product-videos__hit" data-we-pv-hit aria-label="Video pausieren"></button>';
  const metaCache = {};
  let youtubeApiPromise = null;

  function loadYoutubeApi() {
    if (window.YT && typeof window.YT.Player === 'function') {
      return Promise.resolve(window.YT);
    }

    if (youtubeApiPromise) return youtubeApiPromise;

    youtubeApiPromise = new Promise((resolve) => {
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof previous === 'function') previous();
        resolve(window.YT);
      };

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
      }

      if (window.YT && typeof window.YT.Player === 'function') {
        resolve(window.YT);
      }
    });

    return youtubeApiPromise;
  }

  function extractVimeoId(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';

    let match = raw.match(/\/playback\/(\d+)/i);
    if (match) return match[1];

    match = raw.match(/\/external\/(\d+)/i);
    if (match) return match[1];

    match = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
    if (match) return match[1];

    if (/vimeo\.com/i.test(raw)) {
      match = raw.match(/(?:^|\/)(\d{6,})(?:\.\w+)?(?:\/|\?|$)/);
      if (match) return match[1];
    }

    if (/^\d+$/.test(raw)) return raw;
    return '';
  }

  function parseVideo(value) {
    if (!value) return null;
    const raw = String(value).trim();
    if (!raw) return null;

    const vimeoId = extractVimeoId(raw);
    if (vimeoId && (/vimeo\.com/i.test(raw) || /^\d+$/.test(raw))) {
      return { provider: 'vimeo', id: vimeoId };
    }

    let match = raw.match(
      /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i
    );
    if (match) return { provider: 'youtube', id: match[1] };

    match = raw.match(/[?&]v=([A-Za-z0-9_-]{11})/);
    if (match) return { provider: 'youtube', id: match[1] };

    if (/^[A-Za-z0-9_-]{11}$/.test(raw)) return { provider: 'youtube', id: raw };

    if (/[A-Za-z_-]/.test(raw)) return { provider: 'youtube', id: raw };
    return vimeoId ? { provider: 'vimeo', id: vimeoId } : { provider: 'vimeo', id: raw };
  }

  function normalizeRawId(value) {
    let trimmed = String(value || '').trim();
    if (!trimmed) return '';

    if (/vimeo\.com/i.test(trimmed)) {
      return extractVimeoId(trimmed);
    }

    if (trimmed.includes('youtu.be/')) {
      trimmed = trimmed.split('youtu.be/')[1].split('?')[0].split('&')[0].trim();
    } else if (trimmed.includes('youtube.com')) {
      if (trimmed.includes('v=')) {
        trimmed = trimmed.split('v=')[1].split('&')[0].trim();
      } else if (trimmed.includes('/embed/')) {
        trimmed = trimmed.split('/embed/')[1].split('?')[0].trim();
      } else if (trimmed.includes('/shorts/')) {
        trimmed = trimmed.split('/shorts/')[1].split('?')[0].trim();
      } else if (trimmed.includes('/live/')) {
        trimmed = trimmed.split('/live/')[1].split('?')[0].trim();
      }
    }

    return trimmed;
  }

  function youtubeThumbUrl(id, quality) {
    return YOUTUBE_THUMB + id + '/' + (quality || 'hqdefault') + '.jpg';
  }

  // YouTube serves a 120x90 placeholder when maxres/sd is missing (often still "loads").
  function isUsableYoutubeThumb(img) {
    return Boolean(img && img.naturalWidth > 120 && img.naturalHeight > 90);
  }

  function resolveYoutubeThumb(id) {
    const qualities = ['maxresdefault', 'sddefault', 'hqdefault'];

    return new Promise((resolve) => {
      let index = 0;

      const tryNext = () => {
        if (index >= qualities.length) {
          resolve(youtubeThumbUrl(id, 'hqdefault'));
          return;
        }

        const url = youtubeThumbUrl(id, qualities[index++]);
        const img = new Image();
        img.onload = () => {
          if (isUsableYoutubeThumb(img)) resolve(url);
          else tryNext();
        };
        img.onerror = tryNext;
        img.src = url;
      };

      tryNext();
    });
  }

  function upgradeVimeoThumb(url) {
    if (!url) return url;
    return String(url)
      .replace(/-d_\d+x\d+/i, '-d_1280')
      .replace(/-d_\d+(?=[?&#]|$)/i, '-d_1280')
      .replace(/_\d+x\d+/i, '_1280');
  }

  function parseVideoList(raw, maxVideos) {
    const limit = Math.max(1, Number(maxVideos) || 5);
    const parts = String(raw || '').split(/[,;]+/);
    const ids = [];
    const seen = {};

    parts.forEach((part) => {
      if (ids.length >= limit) return;
      const id = normalizeRawId(part);
      if (!id || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    });

    return ids;
  }

  function extractYoutubeIdField(variant) {
    const fields = variant?.metafields?.custom?.variants_fields;
    if (!fields) return '';
    const raw = fields.youtubeid ?? fields.YoutubeID;
    if (raw == null) return '';
    if (typeof raw === 'string') return raw;
    if (typeof raw === 'object' && raw.value != null) return String(raw.value);
    return String(raw);
  }

  function videoKey(video) {
    if (!video || !video.id) return '';
    return video.provider + ':' + video.id;
  }

  function formatDuration(seconds) {
    const total = Math.max(0, Math.round(Number(seconds) || 0));
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return mins + ':' + String(secs).padStart(2, '0');
  }

  function loadMeta(video) {
    if (!video || !video.id) return Promise.resolve(null);

    const key = videoKey(video);
    if (metaCache[key]) return metaCache[key];

    if (video.provider === 'youtube') {
      metaCache[key] = Promise.all([
        fetch(YOUTUBE_OEMBED + encodeURIComponent('https://www.youtube.com/watch?v=' + video.id))
          .then((res) => (res.ok ? res.json() : null))
          .catch(() => null),
        resolveYoutubeThumb(video.id)
      ]).then(([data, thumbnail_url]) => ({
        title: data && data.title ? String(data.title) : null,
        thumbnail_url: thumbnail_url || (data && data.thumbnail_url) || youtubeThumbUrl(video.id),
        duration: data && data.duration != null ? data.duration : null
      }));
    } else {
      metaCache[key] = fetch(
        VIMEO_OEMBED + encodeURIComponent('https://vimeo.com/' + video.id) + '&width=1280'
      )
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (!data) return null;
          return {
            title: data.title ? String(data.title) : null,
            thumbnail_url: upgradeVimeoThumb(data.thumbnail_url) || data.thumbnail_url,
            duration: data.duration != null ? data.duration : null
          };
        })
        .catch(() => null);
    }

    return metaCache[key];
  }

  function setPoster(el, thumbnailUrl) {
    if (!el || !thumbnailUrl) return;
    el.style.backgroundImage = "url('" + thumbnailUrl + "')";
  }

  function readVideoFromEl(el) {
    if (!el) return null;
    return parseVideo(el.dataset.videoId || el.dataset.vimeoId || '');
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function initSection(root) {
    if (!root || root.dataset.weProductVideosReady === 'true') return;
    root.dataset.weProductVideosReady = 'true';

    const layout = root.querySelector('[data-we-product-videos-layout]');
    const player = root.querySelector('[data-we-product-videos-player]');
    const poster = root.querySelector('[data-we-product-videos-poster]');
    const iframeWrap = root.querySelector('[data-we-product-videos-iframe-wrap]');
    const listEl = root.querySelector('[data-we-product-videos-list]');
    const listWrap = root.querySelector('[data-we-product-videos-list-wrap]');
    const listFade = root.querySelector('[data-we-product-videos-list-fade]');
    const listMore = root.querySelector('[data-we-product-videos-list-more]');
    const mobileEl = root.querySelector('[data-we-product-videos-mobile-thumbs]');
    const sidebarEl = root.querySelector('[data-we-product-videos-sidebar]');
    const countEl = root.querySelector('[data-we-product-videos-count]');
    const emptyEl = root.querySelector('[data-we-product-videos-empty]');
    const videoTitle = root.dataset.videoTitle || '';
    const videoDescription = root.dataset.videoDescription || '';
    const maxVideos = Number(root.dataset.maxVideos || 5);

    let variantMap = {};
    const mapEl = root.querySelector('[data-we-product-videos-map]');
    if (mapEl) {
      try {
        variantMap = JSON.parse(mapEl.textContent || '{}') || {};
      } catch (error) {
        variantMap = {};
      }
    }

    let items = [];
    let activeIndex = 0;
    let activeVideo = null;
    let activeKey = '';
    let isPlaying = false;
    let isPaused = false;
    let renderToken = 0;
    let ytPlayer = null;
    let vimeoMuted = false;
    let activeProvider = '';

    function getItemsByIndex(index) {
      return items.filter((item) => Number(item.dataset.videoIndex) === Number(index));
    }

    function syncListScroll() {
      if (!listEl) return;

      const canScroll = listEl.scrollHeight > listEl.clientHeight + 1;
      const atBottom = listEl.scrollTop + listEl.clientHeight >= listEl.scrollHeight - 4;
      const showMore = canScroll && !atBottom;

      listWrap?.classList.toggle('has-more', showMore);
      if (listFade) listFade.hidden = !showMore;
      if (listMore) listMore.hidden = !showMore;
    }

    function scrollListItemIntoView(item) {
      if (!listEl || !item || !listEl.contains(item)) return;

      const itemRect = item.getBoundingClientRect();
      const listRect = listEl.getBoundingClientRect();

      if (itemRect.top < listRect.top) {
        listEl.scrollTop -= listRect.top - itemRect.top;
      } else if (itemRect.bottom > listRect.bottom) {
        listEl.scrollTop += itemRect.bottom - listRect.bottom;
      }

      syncListScroll();
    }

    function syncDataset(el, video) {
      if (!el || !video) return;
      el.dataset.videoId = video.id;
      el.dataset.videoProvider = video.provider;
      el.dataset.vimeoId = video.provider === 'vimeo' ? video.id : '';
    }

    function postVimeo(method, value) {
      const iframe = iframeWrap?.querySelector('iframe');
      if (!iframe || !iframe.contentWindow) return;
      const payload = value === undefined ? { method: method } : { method: method, value: value };
      iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
      iframe.contentWindow.postMessage(payload, '*');
    }

    function stopVideo() {
      isPlaying = false;
      isPaused = false;
      vimeoMuted = false;
      activeProvider = '';
      root.classList.remove('is-playing');
      if (ytPlayer && typeof ytPlayer.destroy === 'function') {
        try {
          ytPlayer.destroy();
        } catch (error) {
          /* ignore */
        }
        ytPlayer = null;
      }
      if (iframeWrap) {
        iframeWrap.innerHTML = '';
        iframeWrap.hidden = true;
      }
    }

    function toggleVimeoPause() {
      if (activeProvider !== 'vimeo' || !isPlaying) return;
      isPaused = !isPaused;
      postVimeo(isPaused ? 'pause' : 'play');
      const hitBtn = iframeWrap?.querySelector('[data-we-pv-hit]');
      if (hitBtn) {
        hitBtn.setAttribute('aria-label', isPaused ? 'Video abspielen' : 'Video pausieren');
      }
    }

    function bindChrome(provider) {
      const hitBtn = iframeWrap.querySelector('[data-we-pv-hit]');
      const muteBtn = iframeWrap.querySelector('[data-we-pv-mute]');
      const fsBtn = iframeWrap.querySelector('[data-we-pv-fs]');

      hitBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleVimeoPause();
      });

      muteBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const muted = muteBtn.classList.toggle('is-muted');
        muteBtn.setAttribute('aria-pressed', muted ? 'true' : 'false');

        if (provider === 'youtube' && ytPlayer) {
          if (muted) ytPlayer.mute();
          else ytPlayer.unMute();
          return;
        }

        vimeoMuted = muted;
        postVimeo('setMuted', muted);
      });

      fsBtn?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const target = player || iframeWrap;
        if (document.fullscreenElement) {
          document.exitFullscreen();
          return;
        }

        if (typeof target.requestFullscreen === 'function') {
          target.requestFullscreen();
        } else if (typeof target.webkitRequestFullscreen === 'function') {
          target.webkitRequestFullscreen();
        }
      });
    }

    function playVideo(video) {
      if (!iframeWrap || !video || !video.id) return;
      isPlaying = true;
      isPaused = false;
      vimeoMuted = false;
      activeProvider = video.provider;
      root.classList.add('is-playing');
      iframeWrap.hidden = false;

      if (ytPlayer && typeof ytPlayer.destroy === 'function') {
        try {
          ytPlayer.destroy();
        } catch (error) {
          /* ignore */
        }
        ytPlayer = null;
      }

      if (video.provider === 'youtube') {
        const hostId = 'we-pv-yt-' + root.dataset.sectionId;
        iframeWrap.innerHTML = '<div id="' + hostId + '"></div>' + CHROME_HTML;
        bindChrome('youtube');

        loadYoutubeApi().then((YT) => {
          if (!isPlaying || videoKey(video) !== activeKey) return;

          ytPlayer = new YT.Player(hostId, {
            videoId: video.id,
            width: '100%',
            height: '100%',
            playerVars: {
              autoplay: 1,
              rel: 0,
              modestbranding: 1,
              controls: 0,
              fs: 1,
              iv_load_policy: 3,
              playsinline: 1,
              disablekb: 1,
              cc_load_policy: 0,
              origin: window.location.origin
            },
            events: {
              onReady: function (event) {
                event.target.playVideo();
              }
            }
          });
        });
        return;
      }

      iframeWrap.innerHTML =
        VIMEO_HIT_HTML +
        '<iframe src="' +
        VIMEO_PLAYER_SRC +
        encodeURIComponent(video.id) +
        '?autoplay=1&title=0&byline=0&portrait=0&dnt=1&controls=0" ' +
        'title="Vimeo video" allow="autoplay; fullscreen; picture-in-picture" ' +
        'allowfullscreen loading="lazy"></iframe>' +
        CHROME_HTML;
      bindChrome('vimeo');
    }

    function setActive(item, { play } = { play: false }) {
      if (!item) return;

      const video = readVideoFromEl(item);
      const index = Number(item.dataset.videoIndex || 0);
      if (!video || !video.id) return;

      activeVideo = video;
      activeKey = videoKey(video);
      activeIndex = index;

      syncDataset(player, video);

      items.forEach((entry) => {
        const on = Number(entry.dataset.videoIndex) === activeIndex;
        entry.classList.toggle('is-active', on);
        entry.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      getItemsByIndex(index).forEach((entry) => {
        scrollListItemIntoView(entry);
      });

      loadMeta(video).then((meta) => {
        if (!meta || activeKey !== videoKey(video)) return;
        setPoster(poster, meta.thumbnail_url);
        applyVideoTitle(meta.title, index);

        getItemsByIndex(index).forEach((entry) => {
          const durationEl = entry.querySelector('[data-we-product-videos-duration]');
          if (durationEl && meta.duration) {
            durationEl.textContent = formatDuration(meta.duration);
          }
        });
      });

      if (play || isPlaying) {
        playVideo(video);
      } else {
        stopVideo();
      }
    }

    function bindItem(item) {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const video = readVideoFromEl(item);
        if (!video || !video.id) return;

        const sameSlot = Number(item.dataset.videoIndex) === activeIndex;
        if (sameSlot && !isPlaying) {
          playVideo(video);
          return;
        }

        setActive(item, { play: isPlaying || sameSlot });
      });
    }

    function resolveTitle(metaTitle) {
      const title = metaTitle && String(metaTitle).trim();
      return title || videoTitle || 'Produktvideo';
    }

    function applyVideoTitle(metaTitle, index) {
      const title = resolveTitle(metaTitle);
      const isActive = Number(index) === activeIndex;

      getItemsByIndex(index).forEach((entry) => {
        const titleEl = entry.querySelector('[data-we-product-videos-item-title]');
        if (titleEl) {
          titleEl.textContent = title;
          titleEl.setAttribute('title', title);
        }

        if (entry.classList.contains('we-product-videos__mobile-thumb')) {
          entry.setAttribute('aria-label', title);
        }
      });

      if (isActive) {
        root.querySelectorAll('[data-we-product-videos-player-title]').forEach((el) => {
          el.textContent = title;
          el.setAttribute('title', title);
        });
      }
    }

    function buildListItem(videoId, index) {
      const fallbackTitle = resolveTitle(null);
      const titleHtml =
        '<span class="we-product-videos__item-title" data-we-product-videos-item-title title="' +
        escapeHtml(fallbackTitle) +
        '">' +
        escapeHtml(fallbackTitle) +
        '</span>';
      const descHtml = videoDescription
        ? '<span class="we-product-videos__item-desc">' + escapeHtml(videoDescription) + '</span>'
        : '';

      return (
        '<li>' +
        '<button type="button" class="we-product-videos__item' +
        (index === 0 ? ' is-active' : '') +
        '" data-we-product-videos-item data-video-index="' +
        index +
        '" data-video-id="' +
        escapeHtml(videoId) +
        '" aria-pressed="' +
        (index === 0 ? 'true' : 'false') +
        '">' +
        '<span class="we-product-videos__thumb">' +
        '<span class="we-product-videos__thumb-image" data-we-product-videos-thumb aria-hidden="true"></span>' +
        '<span class="we-product-videos__play we-product-videos__play--sm" aria-hidden="true">' +
        PLAY_ICON +
        '</span>' +
        '</span>' +
        '<span class="we-product-videos__item-copy">' +
        titleHtml +
        descHtml +
        '</span>' +
        '<span class="we-product-videos__duration" data-we-product-videos-duration></span>' +
        '</button>' +
        '</li>'
      );
    }

    function buildMobileThumb(videoId, index) {
      const fallbackTitle = resolveTitle(null);
      return (
        '<button type="button" class="we-product-videos__mobile-thumb' +
        (index === 0 ? ' is-active' : '') +
        '" data-we-product-videos-item data-video-index="' +
        index +
        '" data-video-id="' +
        escapeHtml(videoId) +
        '" aria-label="' +
        escapeHtml(fallbackTitle) +
        '" aria-pressed="' +
        (index === 0 ? 'true' : 'false') +
        '">' +
        '<span class="we-product-videos__thumb">' +
        '<span class="we-product-videos__thumb-image" data-we-product-videos-thumb aria-hidden="true"></span>' +
        '<span class="we-product-videos__play we-product-videos__play--sm" aria-hidden="true">' +
        PLAY_ICON +
        '</span>' +
        '</span>' +
        '</button>'
      );
    }

    function refreshMeta() {
      const uniqueVideos = [];
      const seen = {};

      items.forEach((item) => {
        const video = readVideoFromEl(item);
        const key = videoKey(video);
        if (!key || seen[key]) return;
        seen[key] = true;
        uniqueVideos.push(video);
      });

      if (activeVideo) {
        const key = videoKey(activeVideo);
        if (key && !seen[key]) uniqueVideos.unshift(activeVideo);
      }

      const token = renderToken;
      uniqueVideos.forEach((video) => {
        loadMeta(video).then((meta) => {
          if (!meta || token !== renderToken) return;

          if (videoKey(video) === activeKey) {
            setPoster(poster, meta.thumbnail_url);
          }

          items.forEach((item) => {
            const itemVideo = readVideoFromEl(item);
            if (videoKey(itemVideo) !== videoKey(video)) return;
            const thumb = item.querySelector('[data-we-product-videos-thumb]');
            setPoster(thumb, meta.thumbnail_url);
            applyVideoTitle(meta.title, item.dataset.videoIndex);
            const durationEl = item.querySelector('[data-we-product-videos-duration]');
            if (durationEl && meta.duration) {
              durationEl.textContent = formatDuration(meta.duration);
            }
          });
        });
      });
    }

    function renderVideos(rawValue) {
      renderToken += 1;
      const ids = parseVideoList(rawValue, maxVideos);
      const hasVideos = ids.length > 0;
      const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

      root.hidden = !hasVideos && !isDesignMode;
      if (layout) {
        layout.hidden = !hasVideos;
        layout.classList.toggle('is-single', ids.length < 2);
      }
      if (emptyEl) emptyEl.hidden = hasVideos;
      if (sidebarEl) sidebarEl.hidden = ids.length < 2;
      if (mobileEl) mobileEl.hidden = ids.length < 2;
      if (countEl) countEl.textContent = String(ids.length);

      stopVideo();

      if (poster) poster.style.backgroundImage = '';
      if (player) {
        delete player.dataset.videoId;
        delete player.dataset.videoProvider;
        delete player.dataset.vimeoId;
      }

      if (listEl) listEl.innerHTML = '';
      if (mobileEl) mobileEl.innerHTML = '';
      items = [];
      activeVideo = null;
      activeKey = '';
      activeIndex = 0;

      if (!hasVideos) return;

      if (listEl) {
        listEl.innerHTML = ids.map((id, index) => buildListItem(id, index)).join('');
      }
      if (mobileEl) {
        mobileEl.innerHTML = ids.map((id, index) => buildMobileThumb(id, index)).join('');
      }

      items = Array.from(root.querySelectorAll('[data-we-product-videos-item]'));
      items.forEach(bindItem);

      const firstItem = items[0];
      if (firstItem) {
        setActive(firstItem, { play: false });
      }

      refreshMeta();
      requestAnimationFrame(syncListScroll);
    }

    function resolveRawForVariant(variant) {
      if (!variant) return '';

      const variantId = String(variant.id);
      if (Object.prototype.hasOwnProperty.call(variantMap, variantId)) {
        const fromMap = variantMap[variantId];
        return fromMap == null ? '' : String(fromMap);
      }

      return extractYoutubeIdField(variant);
    }

    function handleVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) {
        renderVideos('');
        return;
      }
      renderVideos(resolveRawForVariant(variant));
    }

    player?.addEventListener('click', (event) => {
      if (event.target.closest('[data-we-product-videos-item]')) return;
      if (event.target.closest('.we-product-videos__chrome')) return;
      if (event.target.closest('[data-we-pv-hit]')) return;
      if (isPlaying) return;
      playVideo(activeVideo);
    });

    player?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target !== player) return;
      event.preventDefault();
      if (isPlaying) return;
      playVideo(activeVideo);
    });

    items = Array.from(root.querySelectorAll('[data-we-product-videos-item]'));
    items.forEach(bindItem);

    activeIndex = items[0] ? Number(items[0].dataset.videoIndex || 0) : 0;
    activeVideo = readVideoFromEl(player) || readVideoFromEl(items[0]);
    activeKey = videoKey(activeVideo);
    refreshMeta();

    listEl?.addEventListener('scroll', syncListScroll, { passive: true });
    listMore?.addEventListener('click', (event) => {
      event.preventDefault();
      if (!listEl) return;
      listEl.scrollBy({ top: Math.max(120, listEl.clientHeight * 0.75), behavior: 'smooth' });
    });
    window.addEventListener('resize', syncListScroll);

    if (listEl && typeof ResizeObserver === 'function') {
      const listResizeObserver = new ResizeObserver(() => syncListScroll());
      listResizeObserver.observe(listEl);
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(syncListScroll);
    });

    root.__weProductVideosOnVariantChange = handleVariantChange;
  }

  function onVariantChange(event) {
    document.querySelectorAll('[data-we-product-videos]').forEach((root) => {
      if (typeof root.__weProductVideosOnVariantChange === 'function') {
        root.__weProductVideosOnVariantChange(event);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-we-product-videos]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (!window.__weProductVideosVariantBound) {
    window.__weProductVideosVariantBound = true;
    document.addEventListener('on:variant:change', onVariantChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-we-product-videos]') || event.target;
    if (root?.matches?.('[data-we-product-videos]')) {
      delete root.dataset.weProductVideosReady;
      initSection(root);
    }
  });
})();
